import { useEffect } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import Lenis from 'lenis';
import { Toaster } from 'sonner';
import { LanguageProvider } from '@/i18n/LanguageContext';
import { SiteImagesProvider } from '@/components/SiteImages';
import { Navbar } from '@/components/Navbar';
import { Footer } from '@/components/Footer';
import { WhatsAppFloat, MobileFABs } from '@/components/WhatsAppFloat';
import { CookieConsent } from '@/components/CookieConsent';
import Home from '@/pages/Home';
import ServicePage from '@/pages/ServicePage';
import Rulouri from '@/pages/Rulouri';
import Portofoliu from '@/pages/Portofoliu';
import Contact from '@/pages/Contact';
import Admin from '@/pages/Admin';
import LegalPage from '@/pages/LegalPage';
import Configurator from '@/pages/Configurator';
import LocalPage from '@/pages/LocalPage';

// Floating contact buttons hidden on /admin (they overlap admin stats on mobile)
const AdminSafeFloats = () => {
  const { pathname } = useLocation();
  if (pathname.startsWith('/admin')) return null;
  return (
    <>
      <WhatsAppFloat />
      <MobileFABs />
    </>
  );
};

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <LanguageProvider>
      <SiteImagesProvider>
      <div className="App bg-paper min-h-screen">
        <BrowserRouter>
          <ScrollToTop />
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/tamplarie-pvc" element={<ServicePage serviceKey="pvc" />} />
            <Route path="/porti-de-garaj" element={<ServicePage serviceKey="garaj" />} />
            <Route path="/rulouri" element={<Rulouri />} />
            <Route path="/automatizari" element={<ServicePage serviceKey="auto" />} />
            <Route path="/portofoliu" element={<Portofoliu />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/politica-cookies" element={<LegalPage pageKey="cookiesPage" />} />
            <Route path="/politica-confidentialitate" element={<LegalPage pageKey="privacyPage" />} />
            <Route path="/configurator" element={<Configurator />} />
            <Route path="/porti-de-garaj-timisoara" element={<LocalPage pageKey="garajTimisoara" />} />
            <Route path="/tamplarie-pvc-timisoara" element={<LocalPage pageKey="pvcTimisoara" />} />
            <Route path="/rulouri-timisoara" element={<LocalPage pageKey="rulouriTimisoara" />} />
            <Route path="/porti-de-garaj-arad" element={<LocalPage pageKey="garajArad" />} />
            <Route path="/tamplarie-pvc-arad" element={<LocalPage pageKey="pvcArad" />} />
            <Route path="/rulouri-arad" element={<LocalPage pageKey="rulouriArad" />} />
            <Route path="/admin" element={<Admin />} />
            {/* Legacy WordPress URLs → new pages (301-style client redirects for Google re-indexing) */}
            <Route path="/despre-noi" element={<Navigate to="/" replace />} />
            <Route path="/despre-noi/" element={<Navigate to="/" replace />} />
            <Route path="/consultanta-alegere-produs" element={<Navigate to="/contact" replace />} />
            <Route path="/consultanta-alegere-produs/" element={<Navigate to="/contact" replace />} />
            <Route path="/masuratori" element={<Navigate to="/configurator" replace />} />
            <Route path="/masuratori/" element={<Navigate to="/configurator" replace />} />
            <Route path="/montaj-specializat" element={<Navigate to="/porti-de-garaj" replace />} />
            <Route path="/montaj-specializat/" element={<Navigate to="/porti-de-garaj" replace />} />
            <Route path="/ferestre-si-usi-pvc-termopan" element={<Navigate to="/tamplarie-pvc" replace />} />
            <Route path="/ferestre-si-usi-pvc-termopan/" element={<Navigate to="/tamplarie-pvc" replace />} />
            <Route path="/ferestre-si-usi-pvc" element={<Navigate to="/tamplarie-pvc" replace />} />
            <Route path="/ferestre-si-usi-pvc/" element={<Navigate to="/tamplarie-pvc" replace />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Footer />
          <AdminSafeFloats />
          <CookieConsent />
          <Toaster theme="dark" position="top-center" />
        </BrowserRouter>
      </div>
      </SiteImagesProvider>
    </LanguageProvider>
  );
}

export default App;
